import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { fetchLanguages } from "../app/actions"

const initialValue = {id: null, TenantID: "", LanguageID: ""}

const AddEditTenantLanguageModal = ({editTenantLanguage = null, show, onHide, onSave, onDelete}) => {
    const [tenantLanguage, setTenantLanguage] = useState(initialValue)
    const languages = useSelector(store => store.app.languages)
    const dispatch = useDispatch()


    useEffect(()=>{
        dispatch(fetchLanguages())
    }, [])

    useEffect(()=>{

        if(editTenantLanguage) {
            setTenantLanguage({
                id: editTenantLanguage.id,
                TenantID: editTenantLanguage.TenantID,
                LanguageID: editTenantLanguage.LanguageID
            })
        } else {
            setTenantLanguage(initialValue)
        }
    }, [show])

    const handleSave = () => {
        onSave(tenantLanguage)
    }

    const handleDelete = () => {
        onDelete(tenantLanguage)
    }

    const handleChange = (e) => {
        setTenantLanguage({
            ...tenantLanguage,
            [e.target.name]: e.target.value
        })
    }

    const handleRadioButtonChange = e => {
        setTenantLanguage({
            ...tenantLanguage,
            [e.target.name]: e.target.value
        })
    }

    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>
                {editTenantLanguage ? "Edit tenant language #" + editTenantLanguage.id : "Create tenant language"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            <Form.Group>
                <Form.Label>Language</Form.Label>
                <Form.Control as="select" name="LanguageID" value={tenantLanguage.LanguageID} onChange={handleChange}>
                    <option value={""}>Pick language</option>
                    {languages && languages.map(language => <option key={language.id} value={language.id}>
                        #{language.id} {language.Description} ({language.IsoLanguage})
                    </option>)}
                </Form.Control>
            </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="default" onClick={onHide}>Cancel</Button>
            {editTenantLanguage && <Button onClick={handleDelete} variant="danger">Delete</Button>}
            <Button onClick={handleSave} disabled={!tenantLanguage.LanguageID}>Save</Button>
        </Modal.Footer>
    </Modal>
}

export default AddEditTenantLanguageModal